interface ContentGenerationState {
	contentGeneration: unknown
}

const selectContentGeneration = (state: ContentGenerationState) => state.contentGeneration

export default selectContentGeneration
